import React from 'react';

import { EditorState, Modifier, CompositeDecorator } from 'draft-js';

const HANDLE_REGEX = /\@[\w]+/g;
// const HASHTAG_REGEX = /\#[\w\u0590-\u05ff]+/g;
const PLUS_REGEX = /\+[\d]+/g;

const styles = {
  root: {
    fontFamily: "'Helvetica', sans-serif",
    padding: 20,
    width: 600,
  },
  editor: {
    border: '1px solid #ddd',
    cursor: 'text',
    fontSize: 16,
    minHeight: 40,
    padding: 10,
  },
  button: {
    marginTop: 10,
    textAlign: 'center',
  },
  handle: {
    color: 'rgba(98, 177, 254, 1.0)',
    direction: 'ltr',
    unicodeBidi: 'bidi-override',
  },
  hashtag: {
    color: '#5CC461',
  },
};

function handleStrategy(contentBlock, callback, contentState) {
  findWithRegex(HANDLE_REGEX, contentBlock, callback);
}

function hashtagStrategy(contentBlock, callback, contentState) {
  findWithRegex(PLUS_REGEX, contentBlock, callback);
}

function findWithRegex(regex, contentBlock, callback) {
  const text = contentBlock.getText();
  let matchArr;
  let start;
  while ((matchArr = regex.exec(text)) !== null) {
    start = matchArr.index;
    callback(start, start + matchArr[0].length);
  }
}

const HandleSpan = (props) => (
  <span style={styles.handle} data-offset-key={props.offsetKey}>
    {props.children}
  </span>
);

function createPlusEntity({ getEditorState, setEditorState, text, start, end }) {
  const editorState = getEditorState();
  const contentState = editorState.getCurrentContent();
  const contentStateWithEntity = contentState.createEntity('meshMoney', 'IMMUTABLE', {
    text,
    start,
    end,
  });
  const entityKey = contentStateWithEntity.getLastCreatedEntityKey();
  const currentSelectionState = editorState.getSelection();
  const plusTextSelection = currentSelectionState.merge({
    anchorOffset: end,
    focusOffset: end,
  });
  const contentStateWithPlus = Modifier.applyEntity(contentStateWithEntity, plusTextSelection, entityKey);
  const newEditorState = EditorState.push(editorState, contentStateWithPlus, 'insert-money');
  // console.log(
  //   'TCL: createPlusEntity -> newEditorState',
  //   convertToRaw(newEditorState.getCurrentContent())
  // );

  setEditorState(newEditorState);
}

const PlusSpan = (props) => (
  // const { contentState, getEditorState, setEditorState, decoratedText, start, end } = props;
  // createPlusEntity({
  //   contentState,
  //   getEditorState,
  //   setEditorState,
  //   text: decoratedText,
  //   start,
  //   end
  // });
  <span style={styles.hashtag} data-offset-key={props.offsetKey}>
    {props.children}
  </span>
);
export default function initialPostFieldEditorState() {
  // const compositeDecorator = new CompositeDecorator([
  //   // {
  //   //   strategy: handleStrategy,
  //   //   component: HandleSpan
  //   // },
  //   {
  //     strategy: hashtagStrategy,
  //     component: HashtagSpan
  //   }
  // ]);
  return EditorState.createEmpty();
}

export function getMergedPlusDecorator(decorators = []) {
  return new CompositeDecorator([
    ...decorators,
    {
      strategy: hashtagStrategy,
      component: PlusSpan,
    },
  ]);
}

export function getDecoratorPlugin() {
  return {
    decorators: [
      {
        strategy: hashtagStrategy,
        component: PlusSpan,
      },
    ],
  };
}
